import { Collapse, Button, useMediaQuery, Box } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useState } from "react";
import theme from "../../../../Theme";
import CoachesSidebarContent from "./SidebarContent";

export default function CoachesSidebar(props) {
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [isOpen, setIsOpen] = useState(false);

  const content = <CoachesSidebarContent {...props} />;

  if (isMobile) {
    return (
      <Box component="aside" sx={{ width: "100%", mb: 1 }}>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<FilterListIcon sx={{ ml: 1, mr: 0 }} />}
          endIcon={isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          onClick={() => setIsOpen(!isOpen)}
          sx={{
            borderRadius: "14px",
            height: 48,
            justifyContent: "space-between",
            px: 2,
            borderColor: "rgba(255,255,255,0.12)",
            color: "rgba(255,255,255,0.8)",
            "&:hover": {
              borderColor: "rgba(255,255,255,0.25)",
            },
          }}
        >
          فیلتر مربیان
        </Button>

        <Collapse in={isOpen} timeout="auto" unmountOnExit>
          <Box
            sx={{
              mt: 1.5,
              borderRadius: "20px",
              border: "1px solid rgba(255,255,255,0.08)",
              backdropFilter: "blur(10px)",
              backgroundColor: "background.paper",
              overflow: "hidden",
            }}
          >
            {content}
          </Box>
        </Collapse>
      </Box>
    );
  }

  return (
    <Box
      component="aside"
      sx={{
        alignSelf: "start",
        borderRadius: "20px",
        backdropFilter: "blur(10px)",
        border: "1px solid rgba(255,255,255,0.08)",
        position: "sticky",
        top: 24,
        backgroundColor: "background.paper",
        overflow: "hidden",
      }}
    >
      {content}
    </Box>
  );
}
